import { useEffect } from 'react';

/**
 * Writes the page scroll progress (0..1) into a CSS custom property
 * `--scroll` on the document root.
 */
export function useScrollProgress(): void {
  useEffect(() => {
    const root = document.documentElement;

    const update = () => {
      const max = root.scrollHeight - root.clientHeight;
      const progress = max > 0 ? root.scrollTop / max : 0;
      root.style.setProperty('--scroll', String(progress));
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
}
